<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async(payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

        payload.items = [];
        setTimeout(async function(){
        let responseTruckTrailers= (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), {vehicleType: ["TRUCK_VUC","TRUCK_TOCO","TRUCK_TRUCK","TRUCK_MECHANICAL_HORSE_SIMPLE","TRUCK_MECHANICAL_HORSE_TRUCADO","TRUCK_MECHANICAL_HORSE_TRACADO"]}, `${Endpoints.systemUsers.popularVehicles}`));
            console.log(responseTruckTrailers);
            payload.chart.data.datasets[0].label = [responseTruckTrailers.data.results[0]._id.manufacturer.name];
            payload.chart.data.datasets[1].label = [responseTruckTrailers.data.results[1]._id.manufacturer.name];
            payload.chart.data.datasets[2].label = [responseTruckTrailers.data.results[2]._id.manufacturer.name];
            payload.chart.data.datasets[3].label = [responseTruckTrailers.data.results[3]._id.manufacturer.name];      
            payload.chart.data.datasets[4].label = [responseTruckTrailers.data.results[4]._id.manufacturer.name];

            payload.chart.data.datasets[0].data  = [responseTruckTrailers.data.results[0].nTrucks];
            payload.chart.data.datasets[1].data  = [responseTruckTrailers.data.results[1].nTrucks];
            payload.chart.data.datasets[2].data  = [responseTruckTrailers.data.results[2].nTrucks];
            payload.chart.data.datasets[3].data  = [responseTruckTrailers.data.results[3].nTrucks];
            payload.chart.data.datasets[4].data  = [responseTruckTrailers.data.results[4].nTrucks];
            console.log(payload.item);
            payload.chart.update();
        },400);

    },
    methods:{
      
      
    }
}
</script>
